import $ from 'jquery';
import axios from 'axios';
import Translator from 'bazinga-translator';

function addNewActivity() {

    var tooltip = function () {
        return '<?xml version="1.0" encoding="utf-8"?>' +
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
            'width="32px" height="32px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">' +
            '<g>' +
            '<path d="M16,32C7.16,32,0,24.84,0,16S7.16,0,16,0c8.84,0,16,7.16,16,16S24.84,32,16,32z M30,16h-8' +
            'c0,2.12-0.16,4.15-0.44,6h7.08C29.51,20.18,30,18.15,30,16z M27.48,24h-6.29c-0.5,2.3-1.21,4.25-2.07,5.64' +
            'C22.57,28.85,25.52,26.8,27.48,24z M12.05,14h7.91c-0.06-1.42-0.18-2.76-0.35-4h-7.21C12.22,11.25,12.1,12.59,12.05,14z M12,16' +
            'c0,2.15,0.14,4.18,0.39,6h7.22c0.25-1.82,0.39-3.85,0.39-6H12z M16,30c1.36,0,2.56-2.38,3.28-6h-6.56C13.44,27.62,14.64,30,16,30z' +
            'M12.87,29.64c-0.85-1.39-1.56-3.33-2.07-5.64H4.52C6.48,26.8,9.43,28.85,12.87,29.64z M2,15.99C2,16,2,16,2,15.99' +
            'c0,2.16,0.49,4.19,1.36,6.01h7.08C10.16,20.15,10,18.13,10,16L2,15.99L2,15.99z M10.05,14c0.07-1.4,0.21-2.74,0.4-4H3.36' +
            'c-0.59,1.24-1.01,2.59-1.21,4H10.05z M4.53,8h6.29c0.5-2.3,1.2-4.25,2.06-5.64C9.44,3.15,6.49,5.2,4.53,8z M16,2' +
            'c-1.36,0-2.55,2.38-3.28,6h6.55C18.55,4.38,17.36,2,16,2z M19.13,2.36C19.98,3.75,20.68,5.7,21.18,8h6.29' +
            'C25.51,5.2,22.56,3.15,19.13,2.36z M28.64,10h-7.08c0.19,1.26,0.33,2.6,0.4,4h7.9C29.64,12.59,29.23,11.24,28.64,10z" fill-rule="evenodd" clip-rule="evenodd" fill="#A6A6A6"/>' +
            '</g>' +
            '</svg>';
    };

    var edit = function () {
        return '<?xml version="1.0" encoding="utf-8"?>' +
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
            'width="20px" height="22px" viewBox="0 0 20 22" style="enable-background:new 0 0 20 22;" xml:space="preserve">' +
            '<path id="edit" style="fill-rule:evenodd;clip-rule:evenodd;" fill="#332F36" d="M18,19.9V22h-1v-2.1c-1.1-0.2-2-1.2-2-2.4' +
            'c0-1.2,0.9-2.2,2-2.4V0h1v15.1c1.1,0.2,2,1.2,2,2.4C20,18.7,19.1,19.7,18,19.9z M17.5,16c-0.8,0-1.5,0.7-1.5,1.5' +
            'c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5C19,16.7,18.3,16,17.5,16z M13,12.9V22h-1v-9.1c-1.1-0.2-2-1.2-2-2.4s0.9-2.2,2-2.4V0' +
            'h1v8.1c1.1,0.2,2,1.2,2,2.4S14.1,12.7,13,12.9z M12.5,9C11.7,9,11,9.7,11,10.5c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5' +
            'C14,9.7,13.3,9,12.5,9z M8,5.9V22H7V5.9C5.9,5.7,5,4.7,5,3.5c0-1.2,0.9-2.2,2-2.4V0h1v1.1c1.1,0.2,2,1.2,2,2.4C10,4.7,9.1,5.7,8,5.9' +
            'z M7.5,2C6.7,2,6,2.7,6,3.5S6.7,5,7.5,5C8.3,5,9,4.3,9,3.5S8.3,2,7.5,2z M3,10.9V22H2V10.9c-1.1-0.2-2-1.2-2-2.4' +
            'c0-1.2,0.9-2.2,2-2.4V0h1v6.1c1.1,0.2,2,1.2,2,2.4C5,9.7,4.1,10.7,3,10.9z M2.5,7C1.7,7,1,7.7,1,8.5C1,9.3,1.7,10,2.5,10' +
            'C3.3,10,4,9.3,4,8.5C4,7.7,3.3,7,2.5,7z"/>' +
            '</svg>';
    };
    var preview = function () {
        return '<?xml version="1.0" encoding="utf-8"?> ' +
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
            'width="22px" height="22px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"> ' +
            '<path id="preview" style="fill-rule:evenodd;clip-rule:evenodd;" fill="#332F36" d="M21.9,21.9c-0.2,0.2-0.6,0.2-0.8,0l-5.2-5.2 ' +
            'c-1.7,1.5-3.9,2.4-6.3,2.4C4.3,19,0,14.8,0,9.5C0,4.3,4.3,0,9.5,0C14.8,0,19,4.3,19,9.5c0,2.4-0.9,4.6-2.4,6.3l5.2,5.2 ' +
            'C22.1,21.3,22.1,21.6,21.9,21.9z M18,9.5c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5 ' +
            'C14.2,18,18,14.2,18,9.5z M8.6,12.4C8.6,12.4,8.6,12.4,8.6,12.4c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1c0,0,0,0,0-0.1 ' +
            'L5.1,9.7C4.9,9.5,4.9,9.2,5.1,9c0.2-0.2,0.5-0.2,0.7,0l2.4,2.4l5.1-5.1c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L8.6,12.4z"/> ' +
            '</svg>';
    };
    var cover = function () {
        return '<?xml version="1.0" encoding="utf-8"?> ' +
            '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
            'width="22px" height="22px" viewBox="0 0 22 22" style="enable-background:new 0 0 22 22;" xml:space="preserve"> ' +
            '<path id="preview" style="fill-rule:evenodd;clip-rule:evenodd;" fill="#332F36" d="M21.9,21.9c-0.2,0.2-0.6,0.2-0.8,0l-5.2-5.2 ' +
            'c-1.7,1.5-3.9,2.4-6.3,2.4C4.3,19,0,14.8,0,9.5C0,4.3,4.3,0,9.5,0C14.8,0,19,4.3,19,9.5c0,2.4-0.9,4.6-2.4,6.3l5.2,5.2 ' +
            'C22.1,21.3,22.1,21.6,21.9,21.9z M18,9.5c0-4.7-3.8-8.5-8.5-8.5c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5 ' +
            'C14.2,18,18,14.2,18,9.5z M8.6,12.4C8.6,12.4,8.6,12.4,8.6,12.4c-0.1,0.2-0.3,0.2-0.4,0.2c-0.1,0-0.3,0-0.4-0.1c0,0,0,0,0-0.1 ' +
            'L5.1,9.7C4.9,9.5,4.9,9.2,5.1,9c0.2-0.2,0.5-0.2,0.7,0l2.4,2.4l5.1-5.1c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7L8.6,12.4z"/> ' +
            '</svg>';
    };

    axios({
        method: 'get',
        url: '/panel/activity-feed/data?length=1&start=0',
        responseType: 'json',
    })
        .then((response) => {

            var client = function () {
                if (response.data.activities[0].client != null) {
                    return '<p class="c-activity-feed__esti-client">Client: <a href="' + response.data.activities[0].clientURL + '">' + response.data.activities[0].client + '</a></p>';
                } else {
                    return '';
                }
            };

            var clientLetter = function () {
                if (response.data.activities[0].client != null) {
                    return '<span class="table__client-initial">' + response.data.activities[0].client + '</span>';
                } else {
                    return '';
                }
            };

            var template = '<tr class="c-activity-feed__item c-activity-feed__item--' + response.data.activities[0].typeIcon + ' activity-notification-item has-appeared is-unread">' +
                '<td class="c-activity-feed__when">' +
                '<time class="c-activity-feed__time">' + response.data.activities[0].time + '</time>' +
                '<time class="c-activity-feed__date">' + response.data.activities[0].date + '</time>' +
                '</td>' +

                '<td class="c-activity-feed__cover">' +
                // '<div class="esti-template__cover-micro" ' +
                // 'style="background-image: url(' + response.data.activities[0].cover + ')">' +
                // '<div style="background-color:' + response.data.activities[0].coverColor + '"></div>' +
                // '</div>' +
                '<a href=' + response.data.activities[0].titleURL + '>' +
                clientLetter() +
                cover() +
                '</a>' +
                '</td>' +

                '<td class="c-activity-feed__esti-details">' +
                '<a href=' + response.data.activities[0].titleURL + '>' +
                '<h3>' + response.data.activities[0].title + '</h3>' +
                '</a>' +
                '<div>' +
                client() +
                '<p class="c-activity-feed__esti-date">' + Translator.trans('activity_feed.created', [], 'app') + ' <span>' + response.data.activities[0].crdate + '</span></p>' +
                '<p>' + Translator.trans('activity_feed.ip', [], 'app') + ' <span>' + response.data.activities[0].ip + '</span></p>' +
                '</div>' +
                '</td>' +

                '<td class="c-activity-feed__ip"><div>' +
                '<div class="tooltip">' +
                tooltip() +
                '<div class="tooltip__text">' + response.data.activities[0].userAgent + '</div>' +
                '</div>' +
                '</div>' +
                '<p>' + Translator.trans('activity_feed.ip', [], 'app') + ' <span>' + response.data.activities[0].ip + '</span></p>' +
                '</td>' +

                '<td class="c-activity-feed__opt">' +
                '<a href="' + response.data.activities[0].previewURL + '" title="' + Translator.trans('activity_feed.preview', [], 'app') + '" target="_blank"><span>' + Translator.trans('activity_feed.preview', [], 'app') + '</span> ' + preview() + '</a>' +
                '<a href="' + response.data.activities[0].titleURL + '" title="' + Translator.trans('activity_feed.edit_mode', [], 'app') + '"><span>' + Translator.trans('activity_feed.edit_mode', [], 'app') + '</span> ' + edit() + '</a>' +
                '</td>' +

                '<td class="c-activity-feed__message">' +
                '<h5>' + response.data.activities[0].typeLabel + '</h5>' +
                '</td>' +

                '<td class="c-activity-feed__icon">' +
                '<div class="c-activity-feed__svg"></div>' +
                '<div class="c-activity-feed__svg c-activity-feed__svg--active"></div>' +
                '</td>' +

                '</tr>';

            $('.js-notifications-table:first-of-type tbody').prepend(template);

            $('.activity-notification-item.has-appeared').hide().slideDown('slow');


        })
        .then(() => {

            setTimeout(function () {
                $('.activity-notification-item').removeClass('has-appeared');
            }, 3000);

        })
        .catch((response) => {
            console.log(response);
        });

}

function init() {

    if ($('#activity-feed').length > 0) addNewActivity();

}

export {init};


// WEBPACK FOOTER //
// ./src/_app/layout/activity-feed.js